document.addEventListener('DOMContentLoaded', function () {
  if (window.__auBiscuitBundleInitialized) return;
  window.__auBiscuitBundleInitialized = true;

  const BUNDLE_SELECTOR = 'biscuits-bundle-volume-discounts';
  const OBSERVER_CONFIG_ALL = {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  };

  function getBundleElement() {
    return document.querySelector(BUNDLE_SELECTOR);
  }

  function getCheckmarkLabelContainer() {
    return (
      document.querySelector('.el-au-biscuit-bundle-container[data-checkmark-label]') ||
      document.querySelector('.el-au-biscuit-bundle-container')
    );
  }

  function getCheckmarkLabel() {
    const container = getCheckmarkLabelContainer();
    const value = container?.dataset?.checkmarkLabel?.trim();
    return value && value.length ? value : '';
  }

  function observeBundleMutations(callback, config) {
    const bundleElement = getBundleElement();
    if (!bundleElement) return null;

    const observer = new MutationObserver(callback);
    observer.observe(bundleElement, config || OBSERVER_CONFIG_ALL);
    return observer;
  }

  function observeBundleFormMutations(callback, config) {
    const bundleForm = document.querySelector('biscuits-bundle-form');
    if (!bundleForm) return null;

    const observer = new MutationObserver(callback);
    observer.observe(bundleForm, config || OBSERVER_CONFIG_ALL);
    return observer;
  }

  function getBundleProductCards() {
    return document.querySelectorAll('.biscuits-bundle-item-card');
  }

  function firstUrlFromSrcset(srcset) {
    if (!srcset) return '';
    return srcset.split(',')[0].trim().split(/\s+/)[0];
  }

  function getBundleItemImageSrc(productCard) {
    if (!productCard) return '';

    const dataAttrSrc = Array.from(productCard.attributes)
      .concat(
        ...Array.from(productCard.querySelectorAll('biscuits-bundle-item-image, [class*="bundle-item-image"]')).flatMap(
          (el) => Array.from(el.attributes)
        )
      )
      .map((attr) => attr.value)
      .find((value) => typeof value === 'string' && /^https?:\/\//.test(value));

    if (dataAttrSrc) return dataAttrSrc;

    const candidates = [
      productCard.querySelector('biscuits-bundle-item-image'),
      productCard.querySelector('.biscuits-bundle-item-image'),
      productCard.querySelector('img.biscuits-bundle-item-image'),
      productCard.querySelector('[class*="bundle-item-image"]'),
      productCard.querySelector('img'),
    ].filter(Boolean);

    for (const imageEl of candidates) {
      const img =
        imageEl.tagName === 'IMG'
          ? imageEl
          : imageEl.querySelector('img') || imageEl.shadowRoot?.querySelector('img');

      const fromImg = img
        ? img.currentSrc ||
          img.src ||
          img.getAttribute('src') ||
          img.getAttribute('data-src') ||
          img.getAttribute('data-original') ||
          firstUrlFromSrcset(img.getAttribute('srcset'))
        : '';

      const fromHost =
        imageEl.getAttribute('src') ||
        imageEl.getAttribute('data-src') ||
        imageEl.getAttribute('data-original') ||
        imageEl.getAttribute('data-image-url') ||
        imageEl.getAttribute('image') ||
        imageEl.getAttribute('image-url');

      let src = (fromImg || fromHost || '').trim();
      if ((!src || src === 'about:blank') && imageEl.shadowRoot) {
        const shadowImg = imageEl.shadowRoot.querySelector('img');
        if (shadowImg) {
          src = (
            shadowImg.currentSrc ||
            shadowImg.src ||
            shadowImg.getAttribute('src') ||
            firstUrlFromSrcset(shadowImg.getAttribute('srcset')) ||
            ''
          ).trim();
        }
      }

      if (src && src !== 'about:blank') return src;
    }

    return '';
  }

  function escapeHtmlAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  let bundleAtcIsAdding = false;

  function getSelectedBundleQuantity() {
    let total = 0;

    getBundleProductCards().forEach((card) => {
      const input = card.querySelector('.biscuits-bundle-quantity__input');
      total += parseInt(input?.value, 10) || 0;
    });

    if (total === 0) {
      document.querySelectorAll('.el-au-product-variant-card .el-au-qty-input').forEach((input) => {
        total += parseInt(input.value, 10) || 0;
      });
    }

    return total;
  }

  function updateBundleAtcButtons() {
    const hasSelection = getSelectedBundleQuantity() > 0;
    const enabled = hasSelection && !bundleAtcIsAdding;

    document.querySelectorAll('.el-au-biscuit-bundle-atc').forEach((btn) => {
      if (!btn.dataset.auDefaultLabel) {
        btn.dataset.auDefaultLabel = (btn.textContent || 'Add to cart').trim();
      }

      btn.disabled = !enabled;
      btn.classList.toggle('el-au-atc-disabled', !enabled);
      btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');

      if (bundleAtcIsAdding) {
        btn.textContent = 'Adding...';
        btn.classList.add('el-au-atc-loading');
      } else {
        btn.textContent = btn.dataset.auDefaultLabel;
        btn.classList.remove('el-au-atc-loading');
      }
    });
  }

  function setupDiscountInfo() {
    const bundleElement = getBundleElement();
    if (!bundleElement) return;

    document.body.classList.add('el-au-biscuit-bundle-body');

    const offerApplicationTextElems = document.querySelectorAll('.el-au-offer-application-text');

    function getDiscountAmount() {
      const existingDiscountElement = document.querySelector('.biscuits--selected [data-biscuits-discount-amount]')
        ?.textContent;
      const existingDiscountElemWrapper = bundleElement.getAttribute('data-total');
      const currDiscountElement = document.querySelector('#el-au-current-discount-percentage');
      const bottlesCountElement = document.querySelector('#el-au-bottles-count');

      bottlesCountElement.textContent = existingDiscountElemWrapper || '0';

      if (!existingDiscountElement) {
        currDiscountElement.textContent = '0%';
        offerApplicationTextElems.forEach((el) => {
          el.textContent = 'no offer applied';
        });
        return;
      }

      currDiscountElement.textContent = existingDiscountElement;
      offerApplicationTextElems.forEach((el) => {
        el.textContent = `${existingDiscountElement} off applied`;
      });
    }

    observeBundleMutations(() => {
      getDiscountAmount();
    });
  }

  function setupProgressBar() {
    const bundleElement = getBundleElement();
    const leftBottlesValue = document.querySelector('#el-au-left-bottles-value');
    const progressPercentage = document.querySelector('#el-au-progress-percentage');
    const progressFull = document.querySelector('.el-au-unlocked-all-discount-text');
    const progressBeforeFull = document.querySelector('.el-au-progress-to-reward-text');
    const bottlesRemainingCount = document.querySelector('.el-au-remaining-bottle');
    const stickyTextIndicatorContent = document.querySelectorAll('.el-au-bottom-sticky-text-container');
    const stickyTextIndicatorContentSuccess = document.querySelectorAll(
      '.el-au-bottom-sticky-text-container-success'
    );

    if (!bundleElement) return;

    function extractQuantity(tier) {
      const direct = tier.getAttribute('data-biscuits-quantity');
      if (direct) return direct;
      const nested = tier.querySelector(':scope > [data-biscuits-quantity]');
      if (nested) return nested.getAttribute('data-biscuits-quantity');
      const txt = (tier.textContent || '').match(/\d+/);
      return txt ? txt[0] : '';
    }

    function dedupeTierElements(nodeList) {
      const tiers = [];
      const seen = new Set();

      Array.from(nodeList).forEach((el) => {
        const host =
          el.tagName?.toLowerCase() === 'biscuits-bundle-volume-discount-tier'
            ? el
            : el.closest('biscuits-bundle-volume-discount-tier');
        const tier = host || el;
        const qty = parseInt(extractQuantity(tier), 10);
        if (!qty || seen.has(qty)) return;
        seen.add(qty);
        tiers.push(tier);
      });

      tiers.sort((a, b) => parseInt(extractQuantity(a), 10) - parseInt(extractQuantity(b), 10));
      return tiers;
    }

    function getTierElements() {
      const root = bundleElement;
      const selectors = [
        '[data-biscuits-position="header"] biscuits-bundle-volume-discount-tier',
        'biscuits-bundle-volume-discount-tier',
      ];

      for (const sel of selectors) {
        const deduped = dedupeTierElements(root.querySelectorAll(sel));
        if (deduped.length) return deduped;
      }
      return [];
    }

    function getBottleAndParcentageForEachStep() {
      const currProgressValue = document.querySelector('[data-biscuits-discount-amount]');
      const currLeftBottleValue = document.querySelector('[data-biscuits-count-left]');
      if (currLeftBottleValue && leftBottlesValue) leftBottlesValue.textContent = currLeftBottleValue.textContent;
      if (currProgressValue && progressPercentage) progressPercentage.textContent = currProgressValue.textContent;
    }

    // Equal leading & trailing space in the steps row so first and last tier
    // sit off the edges and the progress bar shows a clearly visible journey
    // toward the first tier (1 bottle → halfway to the tier-1 marker).
    const STEPS_EDGE_PADDING = 15;

    function getTierQuantities() {
      return getTierElements()
        .map((t) => parseInt(extractQuantity(t), 10))
        .filter((n) => Number.isFinite(n) && n > 0);
    }

    function computeTierPositions(quantities) {
      const n = quantities.length;
      if (n === 0) return [];
      if (n === 1) return [50];

      const first = quantities[0];
      const last = quantities[n - 1];
      const range = last - first;
      const usable = 100 - STEPS_EDGE_PADDING * 2;

      if (range <= 0) {
        return quantities.map((_, i) => STEPS_EDGE_PADDING + (usable * i) / (n - 1));
      }

      // First tier pinned at STEPS_EDGE_PADDING%, last at (100 - STEPS_EDGE_PADDING)%.
      // Middle tiers distributed proportionally to their bottle-count gaps.
      return quantities.map((q) => STEPS_EDGE_PADDING + (usable * (q - first)) / range);
    }

    function updateStepUI(currentBottleCount) {
      const stepContainers = document.querySelectorAll('.el-au-progress-steps');

      stepContainers.forEach((container) => {
        const steps = container.querySelectorAll('.el-au-progress-step-content');

        let nextStep = null;

        steps.forEach((step) => {
          const svg = step.querySelector('.au-step-content-active-svg');
          const tierQty = parseInt(step.getAttribute('data-tier-quantity'), 10) || 0;
          const isActive = tierQty > 0 && currentBottleCount >= tierQty;

          step.classList.remove('el-au-step-next');

          if (isActive) {
            step.classList.remove('au-text-inactive');
            step.classList.add('au-text-active');
            if (svg) {
              svg.classList.remove('au-step-content-svg-inactive');
              svg.classList.add('au-step-content-svg-active');
            }
          } else {
            step.classList.add('au-text-inactive');
            step.classList.remove('au-text-active');
            if (svg) {
              svg.classList.add('au-step-content-svg-inactive');
              svg.classList.remove('au-step-content-svg-active');
            }
            if (!nextStep && tierQty > 0) nextStep = step;
          }
        });

        if (nextStep) nextStep.classList.add('el-au-step-next');
      });
    }

    function getProgressBarInfo() {
      const progressBarElements = document.querySelectorAll('.el-au-progress-bar');
      const existingDiscountElemWrapper = bundleElement.getAttribute('data-total') || '0';
      const tierQuantities = getTierQuantities();
      const currentBottleCount = parseInt(existingDiscountElemWrapper, 10) || 0;

      const firstTierQty = tierQuantities[0] || 0;
      const lastTierQty = tierQuantities[tierQuantities.length - 1] || 0;
      const allDiscountsUnlocked = lastTierQty > 0 && currentBottleCount >= lastTierQty;

      getBottleAndParcentageForEachStep();

      const tierPositions = computeTierPositions(tierQuantities);
      const lastIdx = tierQuantities.length - 1;

      function computeFillPct(bottles) {
        if (bottles <= 0 || !tierQuantities.length) return 0;
        if (bottles >= tierQuantities[lastIdx]) return 100;

        if (bottles < tierQuantities[0]) {
          return tierQuantities[0] > 0 ? (bottles / tierQuantities[0]) * tierPositions[0] : 0;
        }

        for (let i = 0; i < lastIdx; i++) {
          const qStart = tierQuantities[i];
          const qEnd = tierQuantities[i + 1];
          if (bottles >= qStart && bottles < qEnd) {
            const segEnd = i + 1 === lastIdx ? 100 : tierPositions[i + 1];
            const range = qEnd - qStart;
            return tierPositions[i] + ((bottles - qStart) / range) * (segEnd - tierPositions[i]);
          }
        }

        return 100;
      }

      if (lastTierQty > 0) {
        const fillPct = computeFillPct(currentBottleCount);
        progressBarElements.forEach((bar) => {
          bar.max = 100;
          bar.value = fillPct;
        });
      } else {
        progressBarElements.forEach((bar) => {
          bar.value = 0;
        });
      }

      if (allDiscountsUnlocked) {
        progressFull.classList.remove('el-au-hide-elem');
        stickyTextIndicatorContentSuccess.forEach((element) => {
          element.classList.remove('el-au-hide-elem');
        });
        progressBeforeFull.classList.add('el-au-hide-elem');
        bottlesRemainingCount.classList.add('el-au-hide-elem');
        stickyTextIndicatorContent.forEach((elem) => {
          elem.classList.add('el-au-hide-elem');
        });
      } else {
        progressFull.classList.add('el-au-hide-elem');
        stickyTextIndicatorContentSuccess.forEach((elem) => {
          elem.classList.add('el-au-hide-elem');
        });
        progressBeforeFull.classList.remove('el-au-hide-elem');
        bottlesRemainingCount.classList.remove('el-au-hide-elem');
        stickyTextIndicatorContent.forEach((elem) => {
          elem.classList.remove('el-au-hide-elem');
        });
      }

      updateStepUI(currentBottleCount);
      updateBundleAtcButtons();
    }

    function buildTierMarkup(tierElements) {
      const quantities = tierElements.map((t) => parseInt(extractQuantity(t), 10) || 0);
      const positions = computeTierPositions(quantities);
      const lastIndex = tierElements.length - 1;
      const checkmarkLabel = getCheckmarkLabel();

      return Array.from(tierElements)
        .map((tier, index) => {
          const qty = quantities[index];
          const leftPct = positions[index];

          let translate;
          if (tierElements.length === 1) {
            translate = '-100%';
          } else if (index === 0) {
            translate = '0%';
          } else if (index === lastIndex) {
            translate = '-100%';
          } else {
            translate = '-50%';
          }

          const style = `left:${leftPct}%;transform:translateX(${translate});`;

          const labelTextMarkup = checkmarkLabel
            ? `<span class="el-au-progress-step-label-text"> ${escapeHtmlAttr(checkmarkLabel)}</span>`
            : '';

          return `
          <span class="el-au-progress-step-content au-text-inactive" data-tier-quantity="${qty}" style="${style}">
            <svg class="au-step-content-active-svg au-step-content-svg-inactive" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10ZM7.20703 4.08203C7.38867 3.90039 7.38867 3.59961 7.20508 3.41797C7.02344 3.23438 6.72656 3.23438 6.54297 3.41797L4.375 5.58789L3.45703 4.66992C3.27539 4.48633 2.97852 4.48633 2.79492 4.66992C2.61133 4.85156 2.61133 5.14844 2.79492 5.33203L4.04492 6.58203C4.22656 6.76562 4.52344 6.76562 4.70703 6.58203L7.20703 4.08203Z" fill="#FFDC0E"/>
            </svg>
            <span class="el-au-progress-step-label">${qty}${labelTextMarkup}</span>
          </span>`;
        })
        .join('');
    }

    function fetchProgressbarInfo() {
      const stepContainers = document.querySelectorAll('.el-au-progress-steps');
      const tierElements = getTierElements();

      if (!stepContainers.length) return false;
      if (!tierElements.length) return false;

      const newTiers = buildTierMarkup(tierElements);
      const signature = `${tierElements.map((t) => extractQuantity(t)).join(',')}|${getCheckmarkLabel()}`;

      stepContainers.forEach((element) => {
        const existingCount = element.querySelectorAll('.el-au-progress-step-content').length;
        if (element.dataset.tiersSignature === signature && existingCount === tierElements.length) return;
        element.innerHTML = newTiers;
        element.dataset.tiersSignature = signature;
      });

      return true;
    }

    function ensureTiersRendered() {
      if (fetchProgressbarInfo()) {
        getProgressBarInfo();
        return;
      }
      let attempts = 0;
      const maxAttempts = 40;
      const intervalId = setInterval(() => {
        attempts += 1;
        if (fetchProgressbarInfo() || attempts >= maxAttempts) {
          clearInterval(intervalId);
          getProgressBarInfo();
        }
      }, 250);
    }

    getBottleAndParcentageForEachStep();
    ensureTiersRendered();

    observeBundleMutations(() => {
      fetchProgressbarInfo();
      getProgressBarInfo();
    });

    window.addEventListener('load', () => {
      fetchProgressbarInfo();
      getProgressBarInfo();
    });
  }

  function setupBundleAddToCart() {
    function getBundleHost() {
      return document.querySelector('biscuits-bundle-form');
    }

    function getBundleNativeForm() {
      const host = getBundleHost();
      if (!host) return null;
      if (host instanceof HTMLFormElement) return host;
      return host.querySelector('form') || null;
    }

    function getBundleSubmitButton() {
      const host = getBundleHost();
      if (!host) return null;

      const selectors = [
        '[data-biscuits-add-to-cart]',
        '.biscuits-bundle-form__add-to-cart',
        '.biscuits-bundle-form__submit',
        'button.biscuits-bundle-form__button--submit',
        'button.biscuits-bundle-form__button',
        'button[type="submit"]',
        '[type="submit"]',
      ];

      for (const sel of selectors) {
        const btn = host.querySelector(sel);
        if (btn) return btn;
      }
      return host.querySelector('button') || null;
    }

    function openCartDrawer(productData) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: productData || {} },
        })
      );
      document.dispatchEvent(new CustomEvent('cart:open'));
    }

    async function ajaxAddBundle(form) {
      const formData = new FormData(form);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      let data = null;
      try {
        data = await response.json();
      } catch (_e) {
        data = null;
      }

      if (!response.ok) {
        const message = (data && (data.description || data.message)) || 'Could not add bundle to cart.';
        console.warn('[au-biscuit-bundle] add to cart failed:', message, data);
        return false;
      }

      openCartDrawer(data);
      return true;
    }

    function bindFormInterceptor() {
      const form = getBundleNativeForm();
      if (!form || form.dataset.auSubmitBound === 'true') return;
      form.dataset.auSubmitBound = 'true';

      form.addEventListener(
        'submit',
        async (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (!getSelectedBundleQuantity() || bundleAtcIsAdding) return;

          bundleAtcIsAdding = true;
          updateBundleAtcButtons();

          try {
            await ajaxAddBundle(form);
          } finally {
            bundleAtcIsAdding = false;
            updateBundleAtcButtons();
          }
        },
        true
      );
    }

    async function triggerBundleAdd() {
      bindFormInterceptor();

      const form = getBundleNativeForm();
      if (form) {
        return { keepLoading: false, success: await ajaxAddBundle(form) };
      }

      const host = getBundleHost();
      if (host && typeof host.addToCart === 'function') {
        host.addToCart();
        return { keepLoading: true };
      }

      return { keepLoading: false, success: false };
    }

    ['biscuits--added-to-cart', 'biscuits--cart-updated', 'biscuits--bundle-added'].forEach((eventName) => {
      document.addEventListener(eventName, () => {
        bundleAtcIsAdding = false;
        openCartDrawer();
        updateBundleAtcButtons();
      });
    });

    bindFormInterceptor();
    const host = getBundleHost();
    if (host) {
      new MutationObserver(bindFormInterceptor).observe(host, { childList: true, subtree: true });
    }

    document.querySelectorAll('.el-au-biscuit-bundle-atc').forEach((btn) => {
      if (btn.dataset.auAtcBound === 'true') return;
      btn.dataset.auAtcBound = 'true';
      btn.setAttribute('type', 'button');

      btn.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!getSelectedBundleQuantity() || bundleAtcIsAdding) return;

        bundleAtcIsAdding = true;
        updateBundleAtcButtons();

        try {
          const result = await triggerBundleAdd();
          if (!result?.keepLoading) {
            bundleAtcIsAdding = false;
            updateBundleAtcButtons();
          }
        } catch (_e) {
          bundleAtcIsAdding = false;
          updateBundleAtcButtons();
        }
      });
    });

    updateBundleAtcButtons();
  }

  function setupProductVariants() {
    function parsePriceValue(priceText) {
      if (!priceText) return 0;
      const normalized = priceText.replace(/[^0-9.-]/g, '');
      const value = parseFloat(normalized);
      return Number.isFinite(value) ? value : 0;
    }

    function toggleHeaderPriceBlocks() {
      const defaultPriceBlock = document.querySelector('.el-au-default-product-header-price');
      const bundlePriceBlock = document.querySelector('.el-au-bundle-product-header-price');
      const bundleFinalPriceElement = document.querySelector(
        '.el-au-bundle-product-header-price .el-au-price-final'
      );

      if (!defaultPriceBlock || !bundlePriceBlock || !bundleFinalPriceElement) return;

      const finalPrice = parsePriceValue(bundleFinalPriceElement.textContent);
      const shouldShowBundlePrice = finalPrice > 0;

      defaultPriceBlock.classList.toggle('hide', shouldShowBundlePrice);
      bundlePriceBlock.classList.toggle('hide', !shouldShowBundlePrice);
    }

    function syncVariantImages() {
      const bundleCards = getBundleProductCards();

      document.querySelectorAll('.el-au-product-variant-card').forEach((card, index) => {
        const originalCard = bundleCards[index];
        const imageSrc = getBundleItemImageSrc(originalCard);
        const flex = card.querySelector('.el-au-img-content-flex');
        if (!flex) return;

        let img = flex.querySelector('img.el-au-product-variant-image');
        const placeholder = flex.querySelector('.el-au-product-variant-image--placeholder');

        if (!imageSrc) return;

        if (placeholder) {
          placeholder.remove();
          img = document.createElement('img');
          img.className = 'el-au-product-variant-image';
          img.height = 64;
          img.width = 48;
          img.loading = 'lazy';
          img.alt = '';
          flex.insertBefore(img, flex.firstChild);
        }

        if (img && img.getAttribute('src') !== imageSrc) {
          img.src = imageSrc;
        }
      });
    }

    // create product variant cards based on existing bundle product cards
    function addProductVariants() {
      const productVariantsContainer = document.querySelector('#el-au-product-variants');
      const availableProductsElement = document.querySelector('.el-au-available-products');
      const bundleCards = getBundleProductCards();

      if (!productVariantsContainer || !availableProductsElement) return;

      const signature = `${bundleCards.length}:${Array.from(bundleCards)
        .map((card) => `${card.querySelector('.biscuits-bundle-item__title')?.textContent || ''}:${getBundleItemImageSrc(card)}`)
        .join('|')}`;

      if (productVariantsContainer.dataset.variantsSignature === signature) {
        syncVariantImages();
        return;
      }

      availableProductsElement.textContent = bundleCards.length || '0';
      productVariantsContainer.innerHTML = '';
      productVariantsContainer.dataset.variantsSignature = signature;

      const newProductVariants = Array.from(bundleCards)
        .map((productCard, index) => {
          const title = productCard.querySelector('.biscuits-bundle-item__title')?.textContent?.trim() || '';
          const imageSrc = getBundleItemImageSrc(productCard);
          const price = productCard.querySelector('.biscuits-bundle-price__current')?.textContent;
          const isAvailable = productCard.getAttribute('data-biscuits-available') !== 'false';
          const disabledClass = isAvailable ? '' : ' el-biscuit-disabled';
          const safeSrc = escapeHtmlAttr(imageSrc);
          const safeTitle = escapeHtmlAttr(title);
          const imageMarkup = imageSrc
            ? `<img src="${safeSrc}" alt="" class="el-au-product-variant-image" height="64" width="48" loading="lazy" />`
            : '<span class="el-au-product-variant-image el-au-product-variant-image--placeholder" aria-hidden="true"></span>';
          return `
        <div class="el-au-product-variant-card${disabledClass}" data-index="${index}">
          <div class="el-au-selected-tag el-au-hide-elem">
            selected
          </div>
          <div class="el-au-img-content-flex">
            ${imageMarkup}
            <div class="el-au-product-variant-info">
              <span class="el-au-product-variant-title">${title}</span>
              <span class="el-au-product-variant-price">${price}</span>
            </div>
          </div>
          <div class="el-au-quantity-selector">
            <button type="button" class="el-au-qty-btn el-au-qty-decrease el-au-hide-elem" aria-label="Decrease quantity">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                  <path d="M10.125 6C10.125 6.41484 9.78984 6.75 9.375 6.75H1.125C0.710156 6.75 0.375 6.41484 0.375 6C0.375 5.58516 0.710156 5.25 1.125 5.25H9.375C9.78984 5.25 10.125 5.58516 10.125 6Z" fill="currentColor"/>
                </svg>
            </button>

            <input
                type="number"
                id="quantity-input-${title.replace(/\s+/g, '-').toLowerCase()}"
                class="el-au-qty-input el-au-hide-elem"
                value="0"
                min="0"
                step="1"
                aria-label="Quantity"
            />

            <button type="button" class="el-au-qty-btn el-au-qty-increase" aria-label="Increase quantity">
                <svg class="el-au-qty-increase-svg" xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                  <path d="M6 1.875C6 1.46016 5.66484 1.125 5.25 1.125C4.83516 1.125 4.5 1.46016 4.5 1.875V5.25H1.125C0.710156 5.25 0.375 5.58516 0.375 6C0.375 6.41484 0.710156 6.75 1.125 6.75H4.5V10.125C4.5 10.5398 4.83516 10.875 5.25 10.875C5.66484 10.875 6 10.5398 6 10.125V6.75H9.375C9.78984 6.75 10.125 6.41484 10.125 6C10.125 5.58516 9.78984 5.25 9.375 5.25H6V1.875Z" fill="currentColor"/>
                </svg>
            </button>
            </div>
        </div>
      `;
        })
        .join('');

      productVariantsContainer.insertAdjacentHTML('beforeend', newProductVariants);
      syncVariantImages();
    }

    function syncCustomUI() {
      const customCards = document.querySelectorAll('.el-au-product-variant-card');
      const bundleCards = getBundleProductCards();

      customCards.forEach((card) => {
        if (card.dataset.auSyncBound === 'true') return;
        card.dataset.auSyncBound = 'true';

        const index = card.dataset.index;
        const originalCard = bundleCards[index];

        if (!originalCard) return;

        const originalPlus = originalCard.querySelector('.biscuits-bundle-quantity__button--plus');
        const originalMinus = originalCard.querySelector('.biscuits-bundle-quantity__button--minus');
        const originalInput = originalCard.querySelector('.biscuits-bundle-quantity__input');
        const originalCheckbox = originalCard.querySelector('.biscuits-bundle-item-checkbox');
        const stickyProgressIndicatorContent = document.querySelectorAll('.el-au-bottom-sticky-text-container');
        const stickyProgressIndicatorContentExisting = document.querySelector(
          '.biscuits-bundle-volume-discounts__title-progress'
        );

        const customPlus = card.querySelector('.el-au-qty-increase');
        const customMinus = card.querySelector('.el-au-qty-decrease');
        const customInput = card.querySelector('.el-au-qty-input');

        function updateProgressText() {
          stickyProgressIndicatorContent?.forEach((content) => {
            content.textContent = stickyProgressIndicatorContentExisting?.textContent;
          });
          updateBundleAtcButtons();
        }
        updateProgressText();

        function clickWithoutScroll(targetEl) {
          if (!targetEl) return;
          const scrollX = window.scrollX || window.pageXOffset;
          const scrollY = window.scrollY || window.pageYOffset;
          const activeBefore = document.activeElement;

          targetEl.click();

          const restoreScroll = () => window.scrollTo(scrollX, scrollY);
          restoreScroll();
          requestAnimationFrame(restoreScroll);
          setTimeout(restoreScroll, 0);

          if (
            activeBefore &&
            activeBefore !== document.body &&
            typeof activeBefore.focus === 'function' &&
            document.activeElement !== activeBefore
          ) {
            try {
              activeBefore.focus({ preventScroll: true });
            } catch (_e) {
              activeBefore.focus();
              restoreScroll();
            }
          } else if (document.activeElement && document.activeElement !== document.body) {
            try {
              document.activeElement.blur();
            } catch (_e) {
              /* noop */
            }
            restoreScroll();
          }
        }

        // PLUS
        customPlus.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          clickWithoutScroll(originalPlus);
          customInput.value = originalInput.value;
          updateProgressText();
        });

        // MINUS
        customMinus.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          clickWithoutScroll(originalMinus);
          customInput.value = originalInput.value;
          updateProgressText();
        });

        customInput.addEventListener('change', () => {
          const min = parseInt(originalInput.min, 10) || 1;
          const max = parseInt(originalInput.max, 10) || Infinity;

          let value = parseInt(customInput.value, 10) || min;

          value = Math.max(min, Math.min(max, value));

          originalInput.value = value;
          customInput.value = value;
          originalInput.dispatchEvent(new Event('change', { bubbles: true }));

          updateProgressText();
        });

        originalInput.addEventListener('input', () => {
          customInput.value = originalInput.value;
          updateProgressText();
        });

        card.addEventListener('click', (e) => {
          if (e.target.closest('.el-au-quantity-selector')) return; // prevent conflict
          e.preventDefault();
          clickWithoutScroll(originalCheckbox);
          updateProgressText();
        });
      });

      function cardClickFunc() {
        syncVariantImages();

        document.querySelectorAll('.el-au-product-variant-card').forEach((card, index) => {
          const originalCard = getBundleProductCards()[index];
          const originalInput = originalCard?.querySelector('.biscuits-bundle-quantity__input');

          if (originalCard) {
            const isAvailable = originalCard.getAttribute('data-biscuits-available') !== 'false';
            card.classList.toggle('el-biscuit-disabled', !isAvailable);
          }

          const customInput = card.querySelector('.el-au-qty-input');

          const existingFinalProductPrice = document?.querySelector(
            '.biscuits-bundle-totals .biscuits-bundle-form__total'
          )?.textContent;
          const existingSubtotal = document?.querySelector('.biscuits-bundle-totals .biscuits-bundle-form__compare')
            ?.textContent;
          document.querySelectorAll('.el-au-price-final').forEach((el) => {
            el.textContent = existingFinalProductPrice;
          });
          document.querySelectorAll('.el-au-price-original').forEach((el) => {
            if (existingSubtotal !== existingFinalProductPrice) {
              el.textContent = existingSubtotal;
            } else {
              el.textContent = '';
            }
          });
          toggleHeaderPriceBlocks();

          if (originalInput && customInput) {
            customInput.value = originalInput.value;
          }

          if (originalInput && parseInt(originalInput.value, 10) > 0) {
            card.querySelector('.el-au-selected-tag').classList.remove('el-au-hide-elem');
            card.querySelector('.el-au-qty-decrease').classList.remove('el-au-hide-elem');
            card.querySelector('.el-au-qty-input').classList.remove('el-au-hide-elem');
            card.classList.add('el-au-product-card-border');
            card.querySelector('.el-au-product-variant-image').classList.add('el-au-image-border');
            card.querySelector('.el-au-product-variant-price').classList.add('el-au-variant-selected');
            card.querySelector('.el-au-qty-increase-svg').classList.add('el-au-variant-selected');
          } else {
            card.querySelector('.el-au-selected-tag').classList.add('el-au-hide-elem');
            card.querySelector('.el-au-qty-decrease').classList.add('el-au-hide-elem');
            card.querySelector('.el-au-qty-input').classList.add('el-au-hide-elem');
            card.classList.remove('el-au-product-card-border');
            card.querySelector('.el-au-product-variant-image').classList.remove('el-au-image-border');
            card.querySelector('.el-au-product-variant-price').classList.remove('el-au-variant-selected');
            card.querySelector('.el-au-qty-increase-svg').classList.remove('el-au-variant-selected');
          }
        });

        updateBundleAtcButtons();
      }

      const onBundleFormChange = () => {
        addProductVariants();
        cardClickFunc();
      };

      observeBundleFormMutations(onBundleFormChange, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'data-src', 'data-biscuits-available'],
      });

      observeBundleMutations(onBundleFormChange, {
        subtree: true,
        childList: true,
        attributes: true,
      });
    }

    function ensureVariantsRendered() {
      addProductVariants();
      syncCustomUI();
      syncVariantImages();
      toggleHeaderPriceBlocks();

      let attempts = 0;
      const maxAttempts = 40;
      const intervalId = setInterval(() => {
        attempts += 1;
        const hadImages = document.querySelector('.el-au-product-variant-card img.el-au-product-variant-image[src^="http"]');
        syncVariantImages();
        addProductVariants();
        const hasImages = Array.from(getBundleProductCards()).some((card) => getBundleItemImageSrc(card));
        if ((hasImages && !hadImages) || attempts >= maxAttempts) {
          clearInterval(intervalId);
        }
      }, 250);
    }

    ensureVariantsRendered();
    updateBundleAtcButtons();
  }

  function setupBottomStickyBar() {
    const stickyProgressBar = document.querySelector('.el-au-sticky-discount-elem');
    if (!stickyProgressBar) return;

    const observerTargets = [
      document.querySelector('.el-au-bottom-sticky-progressbar-wrapper'),
      document.querySelector('.el-au-label'),
    ].filter(Boolean);

    const visibilityMap = new Map();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          visibilityMap.set(entry.target, entry.isIntersecting);
        });

        const allHidden = Array.from(visibilityMap.values()).every((v) => !v);

        const isNearTop = window.scrollY < 10;

        if (allHidden && !isNearTop) {
          stickyProgressBar.classList.add('translate-y-full');
        } else {
          stickyProgressBar.classList.remove('translate-y-full');
        }
      },
      { threshold: 0 }
    );

    observerTargets.forEach((el) => observer.observe(el));

    window.addEventListener(
      'scroll',
      () => {
        if (window.scrollY < 100) {
          stickyProgressBar.classList.remove('translate-y-full');
        }
      },
      { passive: true }
    );
  }

  setupDiscountInfo();
  setupProgressBar();
  setupBundleAddToCart();
  setupProductVariants();
  setupBottomStickyBar();
});
